import { IconButton, Tooltip } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useResourceContext } from 'react-admin';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useCosmos } from 'providers/contexts/CosmosContext';
import { getSearchItemInfoBase } from 'components/Search/SearchContextProvider';
import { assetTypesSet, AssetType } from 'utility/types/cosmosTypes';

import { useInlineAsset } from '../context';
import { useEffect, useState } from 'react';

const InlineAssetLink = () => {
  const { activeSite } = useCosmos();
  const { inlineRecord } = useInlineAsset();
  const location = useLocation();
  const resource = useResourceContext();
  const { t } = useTranslation();
  const [info, setInfo] = useState<any>(null);

  useEffect(() => {
    // Get data for standard asset records
    if (
      !inlineRecord?.type ||
      !assetTypesSet.has(inlineRecord.type as AssetType) ||
      !inlineRecord?.uuid
    ) {
      return;
    }
    const data = getSearchItemInfoBase({
      activeSite: activeSite,
      resource,
      record: inlineRecord,
      location,
    });
    setInfo(data);
  }, [inlineRecord, activeSite, resource, location]);

  if (!info?.url || info?.disabled) return null;

  return (
    <Tooltip
      title={t(
        'blox.editorial.toolbar.widgetselect.inline_assets.open_asset_in_new_window',
      )}
    >
      <IconButton
        href={info.url}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <OpenInNewIcon sx={{ fontSize: '1rem' }} />
      </IconButton>
    </Tooltip>
  );
};

export default InlineAssetLink;
